export default {
    400: {
        title: "Pedido ruim",
        header: "@:views.errors.400.title",
        html: "Solicitação inválida. Tente novamente mais tarde."
    },
    401: {
        title: "Ocorreu um erro ao fazer login.",
        header: "@:views.errors.401.title",
        html: "Por favor, entre em contato com <a href='{email}' target='_blank'>o suporte</a> ."
    },
    404: {
        title: "Página não encontrada",
        header: "@:views.errors.404.title"
    },
    403: {
        title: "Acesso não permitido",
        header: "Acesso não permitido",

        contact: "O-I O acesso a periféricos é restrito a funcionários. Se você é um funcionário e está vendo esta mensagem, entre em contato com o departamento de Recursos Humanos da sua empresa para atualizar seu status.",

        subject: "Equipamento - Elegibilidade",

        html: "<p class='text-start'>@:views.errors.403.eligibility @:views.errors.403.contact</p>",
        error: {
            disabled: {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Você não está qualificado(a) no momento. Entre em contato com <a href='#' role='button' data-widget-trigger='{widgetOptions}'>o Suporte</a> para obter mais informações.</p>"
            },
            "not-active": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Você não é elegível no momento. Entre em contato com o departamento de Pessoas e Cultura local para obter mais informações.</p>"
            },
            "not-allowed":{
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>O-I O acesso a periféricos é restrito a funcionários. Se você é um funcionário e está vendo esta mensagem, entre em contato com o departamento de Recursos Humanos da sua empresa para atualizar seu status.</p>"
            },
            "no-manager": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Você não possui um gerente ativo cadastrado em seu perfil do ServiceNow. Entre em contato com o representante local de Pessoas e Cultura para atualizar as informações do seu gerente.</p>"
            },
            "self-manager": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Seu gerente está cadastrado como você em seu perfil do ServiceNow. Entre em contato com o representante local de Pessoas e Cultura para atualizar seu gerente.</p>"
            },
            "no-location": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Você não tem uma localização listada em seu perfil do ServiceNow. Entre em contato com seu representante local de Pessoas e Cultura para atualizar sua localização.</p>"
            },
            eligibility: {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>O-I O acesso a periféricos é restrito a funcionários. Se você é um funcionário e está vendo esta mensagem, entre em contato com o departamento de Recursos Humanos da sua empresa para atualizar seu status.</p>",
            },
            "eligibility-location": {
                header: "",
                html: "Obrigado pelo seu interesse no O-I Periférico. No momento, este programa não está disponível em seu país.",
            },
            "secondary-account": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Você está tentando acessar o O-I Periférico em uma conta secundária. Tente fazer login novamente com sua conta principal.</p>"
            },
            "empty-core-id": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>Sua conta do ServiceNow não possui um nome de usuário. Entre em contato com o representante local de Pessoas e Cultura para atualizar sua conta.</p>"
            },
            country: {
                header: "@:views.errors.403.header",
                html: " @:views.errors.403.eligibility @:views.errors.403.contact",
            },
            "no-permissions": {
                header: "Sem acesso",
                subject: "Sem acesso",
                html: "Você não tem permissão para abrir esta página.",
            },
            "virtual-denied": {
                header: "Parece que você chegou um pouco cedo...",
                html: "<p class='text-start'>Obrigado pelo seu interesse no O-I Peripheral. Parece que você acessou o site antes de ser habilitado e convidado diretamente. O O-I Peripheral está sendo implementado gradualmente, país por país e por grupos de usuários. Após a ativação, você receberá um e-mail com um convite pessoal e instruções.</p><p class='text-start'> Clique em <a href='#' role='button' data-widget-trigger='{widgetOptions}'>Suporte</a> para dúvidas ou problemas com seu pedido ou com o site.</p>",
            }
        }
    },
    500: {
        title: "Erro inesperado",
        header: "@:views.errors.500.title",
        message: "Ocorreu um erro. Tente novamente mais tarde."
    },
    code: {
        title: "Erro inesperado",
        message: "@:views.errors.code.title",
        error: "Erro {code}."
    }
}